import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ProjectDataService from "../services/Project.services";
import CircularProgress from "@mui/material/CircularProgress";

export default function ProjectPicker(props) {
    const [value, setValue] = React.useState(null);
    const [projects, setProjects] = React.useState([]);
    const [inputValue, setInputValue] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);

    const { handleChangeProject, errors } = props;
    const { editing, editObject, token } = props;

    React.useEffect(() => {
        handleClear();
    }, []);

    React.useEffect(() => {
        if (editing) {
            handleInputValue(editObject.hse);
        }
    }, [editing]);

    // Debounced search
    React.useEffect(() => {
        if (inputValue.trim().length < 2) {
            if (inputValue.length === 0 && !value) {
                setProjects([]);
            }
            return;
        }

        const timeoutId = setTimeout(() => {
            searchHSEs(inputValue);
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [inputValue, value]);

    const searchHSEs = (query) => {
        setIsLoading(true);
        ProjectDataService.searchHSEs(query, token)
            .then((response) => {
                setProjects(response.data);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const handleInputValue = (newValue) => {
        setValue(newValue);
        if (!isLoading) handleChangeProject(newValue);
    };

    const handleClear = () => {
        setValue(null);
    };

    return (
        <Autocomplete
            disablePortal
            fullWidth
            autoSelect={false}
            blurOnSelect="touch"
            loading={isLoading}
            value={value}
            onChange={(event, newValue) => {
                if (newValue) {
                    setProjects((prev) => {
                        const exists = prev.some((p) => p.id === newValue.id);
                        return exists ? prev : [newValue, ...prev];
                    });
                }
                handleInputValue(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            options={projects}
            isOptionEqualToValue={(option, newValue) => {
                return option.id === newValue.id;
            }}
            getOptionLabel={(option) =>
                option.number ? `${option.number} ${option.name}` : ""
            }
            noOptionsText={
                inputValue.length < 2 ? "Type to search..." : "No HSEs found"
            }
            renderInput={(params) => (
                <TextField
                    helperText={errors.project === null ? "" : errors.project}
                    error={errors.project ? true : false}
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {isLoading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    id="project"
                    name="project"
                    label={isLoading ? "Searching..." : "Search HSE's"}
                />
            )}
        />
    );
}
